export default __webpack_public_path__ + "static/media/welovehackas.a6cdd077.png";